import css from 'styled-jsx/css';

const style = css``;

export default style;
